module.exports = __webpack_public_path__ + "static/media/Search.ad287e38.svg";